// component/policies/UserPolicyPage.js
import React from "react";
import PolicyPageLayout from "./PolicyPageLayout";


const UserPolicyPage = () => (
  <PolicyPageLayout title="User Policy">
    <p><strong>Last Updated:</strong> June 2025</p>


    <h2>1. User Conduct</h2>
    <p>Users must maintain respectful and lawful behavior while using the Thurent platform. This includes interactions with service providers, other users, and the platform itself.</p>


    <h2>2. Account Responsibilities</h2>
    <ul>
      <li>Provide accurate personal information</li>
      <li>Keep account credentials secure</li>
      <li>Report unauthorized account access immediately</li>
      <li>One account per person</li>
    </ul>


    <h2>3. Booking and Payment</h2>
    <ul>
      <li>Honor confirmed bookings</li>
      <li>Make payments through the platform's authorized payment methods</li>
      <li>Follow the cancellation policy for each service</li>
      <li>Provide accurate event details to service providers</li>
    </ul>


    <h2>4. Prohibited Activities</h2>
    <ul>
      <li>Creating fake accounts or providing false information</li>
      <li>Harassing or threatening service providers</li>
      <li>Attempting to bypass payment systems</li>
      <li>Uploading inappropriate, harmful, or illegal content</li>
      <li>Using the platform for any unlawful purpose</li>
      <li>Scraping or data mining from the platform</li>
    </ul>


    <h2>5. Content Standards</h2>
    <p>Users must not upload content that is offensive, illegal, or violates the rights of others. Thurent has zero tolerance for Child Sexual Abuse Material (CSAM) and will immediately report such content to the relevant authorities.</p>


    <h2>6. Reviews and Feedback</h2>
    <p>Reviews must be honest, relevant, and based on genuine experiences. Fake or defamatory reviews are prohibited and will be removed.</p>


    <h2>7. Account Termination</h2>
    <p>Thurent reserves the right to suspend or terminate user accounts for violation of these policies without prior notice.</p>
  </PolicyPageLayout>
);


export default UserPolicyPage;



